import { createAction, props } from '@ngrx/store';
import { PreauthorizedOffer } from 'src/app/models/state/preauthorized-offer.model';

export const getInitialState = createAction(
	'[Preauthorized Offer] Get Initial State'
);

export const setOfferData = createAction(
	'[Preauthorized Offer] Set Offer Data',
	props<{ offer: PreauthorizedOffer }>()
);

export const selectOfferData = createAction(
	'[Preauthorized Offer] Select Offer Data',
	props<{ offer: PreauthorizedOffer }>()
);

export const addSelectedAmount = createAction(
	'[Preauthorized Offer] Add Selected Amount',
	props<{ selectedAmount: number }>()
);

export const addSelectedTerm = createAction(
	'[Preauthorized Offer] Add Selected Term',
	props<{ selectedTerm: number }>()
);

export const clearOfferState = createAction(
	'[Preauthorized Offer] Clear State'
);

export const setCurpFlowIdentity = createAction(
	'[Preauthorized Offer] Set Curp Flow Identity',
	props<{
		offerPersonId: number;
		productCobisId: string;
		folioDigital: string;
		isApplicantAMember: boolean;
	}>()
);
